// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Table } from '@/ui';
import { StyledWrapper } from '../Styled';

// Models
import { AdminStatus, IAdmin } from '@/models/admins.model';

// Modules
import adminFiltersContainer from '../../containers/AdminFiltersContainer/AdminFiltersContainer';

// Helpers
import { getEntityId } from '@/utils';
import { getAdminsTableColumns } from './columns';

type TAdminsList = {
  adminsList: IAdmin[];
  isLoading: boolean;
  onAdminEdit: (id: string) => void;
  updateAdminStatus: (id: string, status: AdminStatus) => void;
  onDeleteAdmin: (id: string) => void;
};

const AdminsList = ({ isLoading, adminsList, onAdminEdit, updateAdminStatus, onDeleteAdmin }: TAdminsList) => {
  const { t } = useTranslation(['admins']);

  return (
    <StyledWrapper>
      <Table
        columns={getAdminsTableColumns({ t, updateAdminStatus, deleteAdmin: onDeleteAdmin })}
        rowKey="PK"
        scroll={{ x: 'max-content' }}
        loading={isLoading}
        dataSource={adminsList}
        onRow={({ PK }) => ({
          onClick: () => {
            return onAdminEdit(getEntityId(PK));
          },
        })}
        components={{
          header: {
            wrapper: adminFiltersContainer,
          },
        }}
      />
    </StyledWrapper>
  );
};

export default AdminsList;
